import React from 'react';

interface SearchIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const SearchIcon: React.FC<SearchIconProps> = ({
  width = 20,
  height = 17,
  fill = '#6DA6B9',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13 2.3035L18 5.16065V10.8394L13 13.6965L7.99999 10.8394L7.99997 5.16065L13 2.3035ZM20 4V12L13 16L7.07022 12.6116L0.999985 16.1162L-1.52588e-05 14.3842L5.99999 10.9201L5.99997 4L13 0L20 4Z'
        fill={fill}
      />
    </svg>
  );
};

export default SearchIcon;
